// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r9-c";
export var backButton = "_r9-4";
export var backIcon = "_r9-5";
export var chevronShortcut = "_r9-6";
export var container = "_r9-1";
export var editor = "_r9-8";
export var editorWrapper = "_r9-7";
export var prefix = "_r9-2";
export var searchIcon = "_r9-3";
export var suffix = "_r9-9";
export var suffixContent = "_r9-a";
export var suffixText = "_r9-b";
export var wrapper = "_r9-0";